import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Applicationdefs } from '../../core/entities/applicationdefs.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ApplicationdefsService {
    readonly BASE: any = PETICIONES.applicationdefs;

    constructor(private http: HttpClient) { }

  /**
   * @description
   * Obtiene todos los applicationdefs
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un applicationdefs por su id
   */
  public findById(id: number): Observable<any> {
    let idApplicationdefs: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idApplicationdefs).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un applicationdefs en la base de datos
   */
  public postApplicationdef(applicationdefs: Applicationdefs): Observable<any> {
    const json = JSON.stringify(applicationdefs);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postApplicationdefs, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un applicationdefs en la base de datos
   */
  public deleteApplicationdef(applicationdefs: Applicationdefs): Observable<any> {
    let idapplicationdefs: string = (applicationdefs.id !== undefined && applicationdefs.id !== null ? applicationdefs.id + "" : "");
    return this.http.get(this.BASE.deleteApplicationdefs + "/" + idapplicationdefs).pipe(delay(DELAY));
  }

}